import { render, staticRenderFns } from "./VmButton.vue?vue&type=template&id=1a6f1c8c&scoped=true&"
import script from "./VmButton.vue?vue&type=script&lang=js&"
export * from "./VmButton.vue?vue&type=script&lang=js&"
import style0 from "./VmButton.vue?vue&type=style&index=0&id=1a6f1c8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6f1c8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
